/** 使用者登入方式 */
export enum MEMBER_LOGIN_WAY {
  /** 使用者登入方式: FB */
  FACEBOOK = 'facebook',
  /** 使用者登入方式: Google */
  GOOGLE = 'google',
  /** 使用者登入方式: 平台登入 */
  PLATFORM = 'PLATFORM',
  /** 使用者登入方式: 文化部會員中心 */
  CULTURE_CENTER = 'cultureCenter'
}
